var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 26,
    viewBox: "0 0 22 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 22.6429H6.875V14.0714H15.125V22.6429H19.25V9.78571L11 3.35714L2.75 9.78571V22.6429ZM2.75 25.5C1.99375 25.5 1.34613 25.22 0.807127 24.66C0.268127 24.1 -0.000914332 23.4276 2.33447e-06 22.6429V9.78571C2.33447e-06 9.33333 0.0976271 8.90476 0.292877 8.5C0.488127 8.09524 0.757169 7.7619 1.1 7.5L9.35 1.07143C9.60208 0.880952 9.86562 0.738095 10.1406 0.642857C10.4156 0.547619 10.7021 0.5 11 0.5C11.2979 0.5 11.5844 0.547619 11.8594 0.642857C12.1344 0.738095 12.3979 0.880952 12.65 1.07143L20.9 7.5C21.2437 7.7619 21.5132 8.09524 21.7085 8.5C21.9037 8.90476 22.0009 9.33333 22 9.78571V22.6429C22 23.4286 21.7305 24.1014 21.1915 24.6614C20.6525 25.2214 20.0053 25.5009 19.25 25.5H12.375V16.9286H9.625V25.5H2.75Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.1d9a3c43e7aaa615015b1002747956f8.svg";
export { ForwardRef as ReactComponent };